<template>
  <v-dialog v-model="dialog" width="382px">
    <v-card class="py-10 dialog" >
      <v-card-text class="title-dialog">
        {{message}}
      </v-card-text>
      <v-card-actions class="ma-0 pa-0">
        <v-row class="text-center">
          <v-col cols=6 class="pt-8 pb-0">
            <v-btn text @click.stop="cancel" class="ma-0 btn btn-cancel">{{$t('cancelButton')}}</v-btn>
          </v-col>
          <v-col cols=6 class="pt-8 pb-0">
            <v-btn rounded dark @click.stop="confirm" class="ma-0 btn btn-confirm">{{$t('confirmButton')}}</v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props:{
    confirmDialog:{
      type:Boolean,
      default: false
    },
    message: {
      type: String,
      defualt: ""
    }
  },
  data(){
    return {
      dialog: false
    }
  },
  mounted(){
    this.dialog = this.confirmDialog
  },
  watch:{
    confirmDialog: function(newVal, oldVal) {
      if(newVal !== oldVal){
        this.dialog = newVal
      }
    }
  },
  methods:{
    confirm() {
      this.$emit('confirm')
    },
    cancel() {
      this.$emit('cancel')
    }
  }
}
</script>
<style>
  
  .dialog{
    border-radius: 30px!important;
  }
  .title-dialog{
    font-family: 'Roboto', 'sans-serif';
    font-size: 16px;
    color: #24243a!important;
    text-align: center;
  }
  .btn{
    font-family: 'Roboto', 'sans-serif';
    font-size: 12px!important;
  }
  .btn-confirm{
    background-color: #5f98ed!important;
  }
  .btn-confirm:hover{
    background-color: #5f98ed!important;
  }
  .btn-cancel{
    color: #91919c!important;
  }
  .btn-cancel:hover{
    color: #65656d!important;
  }
  .btn-cancel::before{
    background-color: transparent!important;
  }
</style>